import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-5 d-flex align-items-center justify-content-between" }
const _hoisted_2 = { class: "mb-0" }
const _hoisted_3 = { class: "mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: _ctx.getLink,
        class: "d-flex align-items-center"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "avatar avatar--mini flex-shrink-0 me-1",
            style: _normalizeStyle({ backgroundImage: `url(${_ctx.post.author.avatar})` })
          }, null, 4),
          _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.getAuthorFullName), 1)
        ]),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("div", null, _toDisplayString(_ctx.getFormatDatePost), 1)
    ]),
    _createElementVNode("div", _hoisted_3, "Comments: " + _toDisplayString(_ctx.post?.comments.length), 1)
  ]))
}